<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title></title>
<link href="style.css" rel="stylesheet" type="text/css"/>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="cn">Acknowledgements</p>
<p class="co">This novel could not have been written without the help of Dr Ian Simpson and Dr Chris Goldie, the staff of the Gloucestershire Royal and Cheltenham Hospitals and especially Dr George Asimakoplous and the staff of Bristol Heart Institute; huge thanks to them. I am deeply grateful too to Rev Michael Sanders and Rev Paul Youde, for kindness beyond the simply pastoral.</p>
<p class="pp">Lastly, thanks to Steph Richardson and Shane Forkner, for their brilliant ideas for titles for this and, I hope, future Lina novels, and to Ivor Higgins, for his meticulous and generous oversight of the finished manuscript.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?138d2e2c